import {Component, HostBinding, Input} from '@angular/core';
import {InvoiceSummary} from '../../interfaces/invoicing';

export type InvoiceKind = 'draft' | 'final' | 'credited' | 'credit_note';

export function invoiceKind(invoice: Pick<InvoiceSummary, 'status' | 'credits' | 'credited_by'>): InvoiceKind {
  return invoice.credits ? 'credit_note' : invoice.credited_by ? 'credited' : invoice.status;
}

/** An invoice's status as one chip, the label carrying the meaning and a dot the glance; the same on the invoice and in the lists. */
@Component({
  selector: 'bst-invoice-status',
  template: `<span class="dot" aria-hidden="true"></span>{{ 'invoice.' + kind | translate }}`,
  styles: [`
    :host { display: inline-flex; align-items: center; gap: 6px; padding: 1px 9px 1px 8px; border: 1px solid transparent; border-radius: 999px;
      font-size: 0.75rem; font-weight: 600; line-height: 1.5; white-space: nowrap; vertical-align: middle; }
    .dot { width: 6px; height: 6px; border-radius: 50%; background: var(--dot); flex: none; }
    :host(.draft) { --dot: var(--color-warning-500); background: var(--color-warning-100); color: var(--color-warning-800); }
    :host(.final) { --dot: var(--color-primary-500); background: var(--color-primary-100); color: var(--color-primary-700); }
    :host(.credited) { --dot: var(--color-basic-600); background: var(--color-basic-200); color: var(--color-basic-700); }
    /* A credit note is a document of its own, not a state of one: outlined, hollow dot. */
    :host(.credit_note) { background: transparent; border-color: var(--color-basic-400); color: var(--color-basic-800); }
    :host(.credit_note) .dot { background: none; box-shadow: inset 0 0 0 1.5px var(--color-basic-600); }
  `],
  standalone: false
})
export class InvoiceStatusComponent {
  @Input({required: true}) invoice: Pick<InvoiceSummary, 'status' | 'credits' | 'credited_by'>;

  @HostBinding('class') get kind(): InvoiceKind {
    return invoiceKind(this.invoice);
  }
}
